import { useEffect } from "react"
import { useEmbeddedChat } from "src/context/EmbeddedChatContext"

import { EmbeddedChatBreakpoint } from "./useEmbeddedChatBreakpoint"

interface UseEmbeddedChatKeyboardOptions {
  breakpoint: EmbeddedChatBreakpoint
}

export function useEmbeddedChatKeyboard({ breakpoint }: UseEmbeddedChatKeyboardOptions) {
  const { toggle, close, isDisabled, isOpen } = useEmbeddedChat()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Cmd+K (Mac) or Ctrl+K (Windows/Linux) to toggle
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault()

        if (!isDisabled) {
          toggle()
        }
        return
      }

      // Escape to close (only on tablet/mobile modes)
      if (e.key === "Escape" && isOpen && breakpoint !== "desktop") {
        e.preventDefault()
        close()
        return
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [toggle, close, isDisabled, isOpen, breakpoint])
}
